module.exports = __webpack_public_path__ + "static/media/skills_2.7e72c713.svg";